import {createQueryKeys} from "../../shared/query/query-keys";

export const representativeKeys = createQueryKeys("representatives");

export const representativeMutationKeys = {
  createRepresentative: ["representatives", "mutation", "create-representative"] as const,
  updateRepresentative: ["representatives", "mutation", "update-representative"] as const,
  deleteRepresentative: ["representatives", "mutation", "delete-representative"] as const,
  restoreRepresentative: ["representatives", "mutation", "restore-representative"] as const,
  renewRepresentativeContract: [
    "representatives",
    "mutation",
    "renew-representative-contract",
  ] as const,
  addRepresentativeContact: ["representatives", "mutation", "add-representative-contact"] as const,
  editRepresentativeContact: [
    "representatives",
    "mutation",
    "edit-representative-contact",
  ] as const,
  removeRepresentativeContact: [
    "representatives",
    "mutation",
    "remove-representative-contact",
  ] as const,
  addRepresentativeNote: ["representatives", "mutation", "add-representative-note"] as const,
  editRepresentativeNote: ["representatives", "mutation", "edit-representative-note"] as const,
  removeRepresentativeNote: ["representatives", "mutation", "remove-representative-note"] as const,
  addRepresentativeCommission: [
    "representatives",
    "mutation",
    "add-representative-commission",
  ] as const,
  editRepresentativeCommission: [
    "representatives",
    "mutation",
    "edit-representative-commission",
  ] as const,
  removeRepresentativeCommission: [
    "representatives",
    "mutation",
    "remove-representative-commission",
  ] as const,
} as const;
